import { useModule } from "src/system/useModule.tsx";
import { useClientConfig } from "src/client-config/useClientConfig.ts";

export const useModuleCreateDisabled = (resource: string) => {
  const clientConfig = useClientConfig();
  const { disableCreate } = useModule(resource);
  return typeof disableCreate === "function"
    ? disableCreate({
        clientConfig,
      })
    : disableCreate;
};
